import React from 'react';
import { ReactComponent as OpenedEmailIcon } from 'assets/opened-email.svg';
import { ReactComponent as ClickedIcon } from 'assets/click.svg';
import { SendOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import styles from './EmailAnalytics.module.css';

export const AutomationRowWithEmailStat = ({
  name,
  onClick,
  sent,
  opened,
  clicked,
  active,
  onToggle,
}: {
  name?: string;
  onClick: () => void;
  sent?: number;
  opened?: string;
  clicked?: string;
  active?: boolean;
  onToggle?: (active: boolean) => void;
}) => (
  <div className={styles.automationRow} onClick={onClick}>
    <div className={styles.automationName}>{name}</div>
    <div className={styles.automationStats}>
      <div className={styles.automationStatItem}>
        <SendOutlined className={styles.automationStatIcon} />
        {sent}
      </div>
      <div className={styles.automationStatItem}>
        <OpenedEmailIcon className={styles.automationStatIcon} />
        {opened}
      </div>
      <div className={styles.automationStatItem}>
        <ClickedIcon className={styles.automationStatIcon} />
        {clicked}
      </div>
    </div>
    <div onClick={e => e.stopPropagation()}>
      <Switch
        size="small"
        defaultChecked={active}
        onChange={onToggle}
        className={styles.switch}
      />
    </div>
  </div>
);
